import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import {currentPhotoSessionGroupContactIdAtom} from "shared/atoms/current-photo-session-group-contact-id-atom"
import memo from "set-state-compare/build/memo.js"
import Preview from "components/preview"
import {useLayoutRedirector} from "shared/hooks/use-layout-redirector"
import {useSetRecoilState} from "recoil"

export default memo(shapeComponent(class MerfotoPhotoSessionGroupsCardPhotoCard extends ShapeComponent {
  static defaultProps = {
    showBuyAction: true
  }

  static propTypes = {
    allowDownloadOfPhotos: PropTypes.bool.isRequired,
    photo: PropTypes.instanceOf(Photo).isRequired,
    photoSessionGroupContact: PropTypes.instanceOf(PhotoSessionGroupContact).isRequired,
    showBuyAction: PropTypes.bool
  }

  layoutRedirector = this.hookField()
  setCurrentPhotoSessionGroupContact = this.hookField()

  setup() {
    this.layoutRedirector = useLayoutRedirector()
    this.setCurrentPhotoSessionGroupContact = useSetRecoilState(currentPhotoSessionGroupContactIdAtom)
  }

  onBuyPhotoClicked = (e) => {
    e.preventDefault()

    this.tt.setCurrentPhotoSessionGroupContact(this.p.photoSessionGroupContact.id())

    this.tt.layoutRedirector("merfoto", "reactRoot")
  }

  previewActions() {
    const {allowDownloadOfPhotos, photo, showBuyAction} = this.props
    const actions = []

    if (showBuyAction) {
      actions.push({
        "className": "buy-photo-link",
        "label": I18n.t("js.merfoto.photo_session_groups.card.photo_card.buy"),
        "onClick": this.onBuyPhotoClicked
      })
    }

    if (allowDownloadOfPhotos) {
      actions.push({
        "className": "download-photo-link",
        "data-photo-id": photo.id(),
        "href": photo.url(),
        "label": I18n.t("js.merfoto.photo_session_groups.card.photo_card.download"),
        "target": "_blank"
      })
    }

    return actions
  }

  render() {
    const {className, photo, ...restProps} = this.props
    const previewActionsDeps = [this.p.allowDownloadOfPhotos, this.p.photo, this.p.photoSessionGroupContact, this.props.showBuyAction]
    const previewActions = this.cache("previewActions", () => this.previewActions(), previewActionsDeps)

    return (
      <Preview
        actions={previewActions}
        className={classNames("merfoto-components-photo-session-groups-card-photo-card", className)}
        data-photo-id={photo.id()}
        previewOnHover={false}
        showOpenLink={false}
        thumbnailUrl={photo.thumbnailUrl()}
        type={photo.contentType()}
        url={photo.fullSizeUrl()}
        {...restProps}
      />
    )
  }
}))
